module.exports = __webpack_public_path__ + "img/blog-2-3.07f14f41.webp";